// Copyright (c) 2019 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import WearPartsClaim from '@deere/cps-it.warranty-model-factory/lib/claim-wear-part';
import actions from '../../action-list';
import {checkClaimValidity} from '../services/claim-validation-helper';
import {formatClaimNumber} from '../../../shared/services/format-claim-number';
import {infoAlertBar} from '../../../shared/services/alert-bar';
import {isClaimEditable} from '../../shared/services/claim-shared-helper';
import {postClaim} from '../../shared/repositories';
import {removeEmptyRows} from '../../shared/services/empty-claim-rows';
import {routerActions} from 'react-router-redux';
import {translate} from '../../../shared/services/translation-service';
import {updateIsActionButtonDisabled} from './is-action-button-disabled';

export const createWearPartsClaim = claim =>

    async (dispatch, getState) => {

        updateIsActionButtonDisabled(true)(dispatch);

        dispatch(busyCounter.increaseBusyCounter());

        const trimmedClaim = removeEmptyRows(claim, WearPartsClaim);
        const isValidClaim = getState().claims.wearParts.isValidClaim;

        try {

            const updatedClaim = await postClaim(trimmedClaim, 'wear-parts-claims');

            const selectedAction = updatedClaim.selectedAction.id;
            const validationStatus = updatedClaim.validationFailed;

            if (checkClaimValidity(isValidClaim, validationStatus, selectedAction)) {

                dispatch({
                    type: actions.UPDATE_CLAIM_WEAR_PARTS_IS_VALID_CLAIM,
                    validity: true
                });

            }

            if (['DRAFT', 'SAVE_VALD'].includes(selectedAction) && updatedClaim.claimNumber) {

                dispatch(routerActions.replace(`/claims/wear-parts/edit/${formatClaimNumber(updatedClaim.claimNumber)}`));

            }

            dispatch({
                isEditable: isClaimEditable(validationStatus, updatedClaim.selectedAction),
                type: actions.UPDATE_CLAIM_WEAR_PARTS_IS_EDITABLE
            });

            dispatch({
                type: actions.SET_CLAIM_WEAR_PARTS,
                updatedClaim
            });

            infoAlertBar(translate('CLAIM_UPDATED_SUCCESSFULLY'));

        } catch (error) {

        } finally {

            updateIsActionButtonDisabled(false)(dispatch);

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/validate-claim.js